import { render, staticRenderFns } from "./UsersDashboard.vue?vue&type=template&id=e754756a"
import script from "./UsersDashboard.vue?vue&type=script&lang=ts"
export * from "./UsersDashboard.vue?vue&type=script&lang=ts"
import style0 from "./UsersDashboard.vue?vue&type=style&index=0&id=e754756a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports